import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'et-atoms-journal-card',
  templateUrl: './et-journal-card.component.html',
  styleUrls: ['./et-journal-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EtJournalCardComponent {}
